import { useEffect, useState } from 'react'
import Axios from 'axios'

export const useData = (contains: string) => {
    const [data, setData] = useState<any[]>([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true)
        Axios.get('/gateways', {
            params: { contains },
        })
            .then(res => {
                setData(res.data)
            })
            .catch(err => {
                console.error(err)
            })
            .finally(() => {
                setLoading(false)
            })
    }, [contains])

    return { data, loading }
}
